import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input, Form } from 'reactstrap';
import StatusCode from '../../../util/StatusCode';
import SaveStatus from '../../misc/SaveStatus';
import { useTranslation } from 'react-i18next';
import { CoreFlowSyncModuleInfo } from '../../../models/CoreModels';


interface CreateNewModuleModalProps {
    isOpen: boolean
    toggleModal: () => void
    module: CoreFlowSyncModuleInfo
    title: string
    saveStatus: StatusCode
    createModule: React.MouseEventHandler<HTMLButtonElement>
    updateTitle: React.ChangeEventHandler<HTMLInputElement>
}

const CreateNewModuleModal = (props: CreateNewModuleModalProps) => {
    const { t } = useTranslation(['configuration','common']);

    return <Modal isOpen={props.isOpen} toggle={props.toggleModal}>
        <ModalHeader toggle={props.toggleModal}>{t('modulePresentation.createNew.header')}</ModalHeader>
        <Form>
            <ModalBody>
                <Label>{t('modulePresentation.createNew.label')}</Label>
                <h6 className="bold">{t(`modules.${props.module.moduleTypeName}.title`, { ns: 'common' })}</h6>
                <FormGroup>
                    <Label for="title">{t('modulePresentation.createNew.title')}</Label>
                    <Input type="text" name="title" id="title" placeholder={t('modulePresentation.createNew.titlePlaceholder')} value={props.title} onChange={props.updateTitle} autoComplete="off" required />
                </FormGroup>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={props.toggleModal}>{t('action.close', {ns:'common'})}</Button>
                <Button color="primary" type="submit" onClick={props.createModule} disabled={props.title === '' || props.saveStatus !== StatusCode.NONE}>{t('action.create', { ns: 'common' })}</Button>{' '}
                <SaveStatus
                    saveStatus={props.saveStatus}
                    successMsg={t('modulePresentation.createNew.saveSuccess')}
                />
            </ModalFooter>
        </Form>
    </Modal>;
}

export default CreateNewModuleModal;
